export default __webpack_public_path__ + "static/spot-allergy__skin-allergy-paid-02-513c7006efe5fd22e62687e974700c28.jpg";